import { createTheme } from '@material-ui/core/styles';

export default createTheme({
    palette: {
        primary: {
            light: '#4589b6',
            main: '#176ca4',
            dark: '#104b72',
            contrastText: '#fff'
        },
        secondary: {
            light: '#bdbdbd',
            main: '#efefef',
            dark: '#8d8d8d',
            contrastText: '#000'
        }
    },
});
